import React from "react";
import {
  MdOutlineDashboard,
  MdOutlineWarehouse,
  MdOutlineAccountBalanceWallet,
  MdOutlineAdminPanelSettings,
  MdOutlineApproval,
  MdOutlineSupportAgent
} from "react-icons/md";
import { FaBox } from 'react-icons/fa';
import { BsFillShieldLockFill, BsBoxSeamFill } from "react-icons/bs";
import { FcStatistics } from "react-icons/fc";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { AiOutlineAudit } from "react-icons/ai";
import { GiBreakingChain, GiCardPick } from "react-icons/gi";
import { TbReportSearch, TbTruckLoading, TbTruckDelivery } from "react-icons/tb";
import { FaPeopleArrows, FaBoxesPacking } from "react-icons/fa6";
import { ImDownload, ImBarcode } from "react-icons/im";
import { GrRevert } from "react-icons/gr";
import { SiSap } from "react-icons/si";
import { IoAppsSharp } from "react-icons/io5";
import { LuSquareMousePointer } from "react-icons/lu";

const iotInpect = require('../assets/img/icons/eos-icons_iot.jpg');

export default function getSidebarIcons(parsedData) {
  const defaultIcons = {
    'Home': <MdOutlineDashboard />,
    'Authorization': <BsFillShieldLockFill />,
    'Companies': <HiOutlineBuildingOffice2 />,
    'Reports': <TbReportSearch />,
    'D2C Reports': <FaPeopleArrows />,
    'Production Statistics': <FcStatistics/>,
    'D2C PACKING': <FaBoxesPacking />,
    'Products': <BsBoxSeamFill />,
    'Wallet': <MdOutlineAccountBalanceWallet />,
    'Delivery Details': <TbTruckDelivery />,
    'PickList': <GiCardPick />,
    'WMS': <MdOutlineWarehouse />,
    'Assign Serial Number': <ImBarcode />,
    'Download Serial Number': <ImDownload />,
    'UNBIND SERIAL NUMBER': <GiBreakingChain />,
    'Revert Serial Number': <GrRevert />,
    'Dispatch': <TbTruckLoading />,
    'IOT Inspect': <LuSquareMousePointer />,
    'SAP': <SiSap />,
    'Audit Log': <AiOutlineAudit />,
    'Admin Data': <MdOutlineAdminPanelSettings />,
    'App Management': <IoAppsSharp />,
    'IQC': <MdOutlineApproval />,
    'Inspect IOT': <LuSquareMousePointer />,
    'Support':<MdOutlineSupportAgent/>
  };

  const featureBasedIcons = parsedData.features.map((ele, index) => {
    
    return {
      name: ele.name, 
      icon: defaultIcons[ele.name] ?? <FaBox />,
    };
  });

  return featureBasedIcons;
}
